import { Label } from 'components/shared/Label';
import { ETimelineType, ETripEvent } from 'detailsv2/structure';
import i18n from 'i18n';

import { transformTime } from '../../../functions';
import { IDayTripEvent } from '../../../types';
import s from '../../index.module.css';
import { EventOptionConfig } from '../../types';

const AccommodationOption = ({
  data,
  timelineType,
  timeFormat,
}: IDayTripEvent<ETripEvent.Accommodation> & EventOptionConfig) => {
  const { checkIn, checkOut, isAlternate, displaySettings } = data;
  const symbol = (checkIn && checkOut && ' - ') || (checkIn && !checkOut && ' · ');
  switch (timelineType) {
    case ETimelineType.OneDay:
      return (
        <div className={s.checkIn}>
          <span>
            <span data-block style={{ marginRight: '8px' }}>
              {transformTime(checkIn, timeFormat)} {symbol}{' '}
              {checkIn && checkOut && `${transformTime(checkOut, timeFormat)} · `}
              {displaySettings?.checkIn}{' '}
            </span>
            {isAlternate && (
              <Label
                color="#65ADFF"
                text={i18n.t('proposal_content.event_details.tags.alternate')}
                className={s.alternateLabel}
              />
            )}
          </span>
        </div>
      );
    case ETimelineType.Start:
      return (
        <div className={s.checkIn}>
          <span>
            <span style={{ marginRight: '8px' }}>
              <span data-block>
                {checkIn && `${transformTime(checkIn, timeFormat)} - `}
                {displaySettings?.checkIn}
              </span>
            </span>
            {isAlternate && (
              <Label
                color="#65ADFF"
                text={i18n.t('proposal_content.event_details.tags.alternate')}
                className={s.alternateLabel}
              />
            )}
          </span>
        </div>
      );
    case ETimelineType.Middle:
      return (
        <div className={s.checkIn}>
          <span>
            <span data-block style={{ marginRight: '8px' }}>
              {displaySettings?.overnight}
            </span>
            {isAlternate && (
              <Label
                color="#65ADFF"
                text={i18n.t('proposal_content.event_details.tags.alternate')}
                className={s.alternateLabel}
              />
            )}
          </span>
        </div>
      );
    case ETimelineType.End:
      return (
        <div className={s.checkIn}>
          <span>
            <span data-block style={{ marginRight: '8px' }}>
              {checkOut && `${transformTime(checkOut, timeFormat)} - `}
              {displaySettings?.checkOut}
            </span>
            {isAlternate && (
              <Label
                color="#65ADFF"
                text={i18n.t('proposal_content.event_details.tags.alternate')}
                className={s.alternateLabel}
              />
            )}
          </span>
        </div>
      );
    default:
      return null;
  }
};

export default AccommodationOption;
